import SvgComponent from './svg';

export default SvgComponent;
